// Must match the Closed captions tab index in RoomSettings.
export const ROOM_SETTINGS_CAPTIONS_TAB_INDEX = 4;
